var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMCafeteria(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#2eccb6;}.cls-3{fill:none;}.cls-4{fill:#329be6;}.cls-5{fill:#0b5c96;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_cafeteria"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cafeter\\xEDa"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.25,
    y: 45.25,
    width: 27.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,32.25H21a10.76,10.76,0,0,0-10.74,10.5h27.5A10.76,10.76,0,0,0,27,32.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,54.75H33a4.76,4.76,0,0,0,4.58-3.5H10.42A4.76,4.76,0,0,0,15,54.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21,29.75h6a13.07,13.07,0,0,1,6.52,1.74L32.05,17.42a.41.41,0,0,1,.4-.45H43.76V10.75L33.29.29a.4.4,0,0,0-.57,0L.29,32.72a.4.4,0,0,0,0,.57l7.65,7.65A13.24,13.24,0,0,1,21,29.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "10.25 48.75 15.76 48.75 12.26 45.25 10.25 45.25 10.25 48.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15,54.75h6.75l-3.5-3.5H10.42A4.76,4.76,0,0,0,15,54.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.76 52.51 52.37 46.64 46.51 52.51 51.76 52.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.76 48.75 37.76 45.25 12.26 45.25 15.76 48.75 37.76 48.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,54.75a4.75,4.75,0,0,0,4.58-3.5H18.26l3.5,3.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49.98 16.98 46.26 13.25 46.26 16.98 49.98 16.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72l-8.48-8.48L55.18,43.83,65.72,33.29A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,57.25H24.26l8.46,8.47a.4.4,0,0,0,.57,0L44,55H38.24A7.19,7.19,0,0,1,33,57.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27,32.25H21a10.75,10.75,0,0,0-10.74,10.5H37.75A10.75,10.75,0,0,0,27,32.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.75,52.5H46.51L44,55h9.64a.39.39,0,0,0,.39-.35l1.14-10.82-2.81,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15,54.75a4.76,4.76,0,0,1-4.59-3.5h7.84l-2.5-2.5H10.25v-3.5h2L7.94,40.94a13.52,13.52,0,0,0-.17,1.82h0V43h0v2.26h0v3.5h0V50A7.24,7.24,0,0,0,15,57.25h9.25l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.26,10.78l5-2.48a.42.42,0,0,0,.18-.54l-.76-1.52a.41.41,0,0,0-.54-.17L44,9.12a.4.4,0,0,0-.22.36v1.27l2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.23,19.47,55,22l2.27,2.27L58,17.42a.41.41,0,0,0-.4-.45H50l2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.8,52.5a7.16,7.16,0,0,0,.46-2.5V48.75h0v-3.5h0V43h0v-.22h0a13.23,13.23,0,0,0-4-9.23L34.78,19.47h17.7L50,17H46.26V13.25l-2.5-2.5V17H32.45a.41.41,0,0,0-.4.45l1.48,14.07A13.07,13.07,0,0,0,27,29.75H21A13.24,13.24,0,0,0,7.94,40.94l4.32,4.31h25.5v3.5h-22l2.5,2.5H37.59A4.75,4.75,0,0,1,33,54.75H21.76l2.5,2.5H33A7.19,7.19,0,0,0,38.24,55H44l2.5-2.5ZM10.26,42.75A10.75,10.75,0,0,1,21,32.25h6a10.75,10.75,0,0,1,10.74,10.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "54.97 21.97 52.37 46.64 55.18 43.83 57.24 24.24 54.97 21.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.25,
    y: 45.25,
    width: 27.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,32.25H21a10.75,10.75,0,0,0-10.74,10.5H37.75A10.75,10.75,0,0,0,27,32.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,54.75H33a4.75,4.75,0,0,0,4.58-3.5H10.42A4.76,4.76,0,0,0,15,54.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.48,19.47H34.78l1.48,14.06a13.23,13.23,0,0,1,4,9.23h0V43h0v2.26h0v3.5h0V50a7.16,7.16,0,0,1-.46,2.5h12l3.48-33Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMCafeteria);
export default __webpack_public_path__ + "static/media/m_cafeteria.91e3a34bf6ac095277dfbe3b05cd40ee.svg";
export { ForwardRef as ReactComponent };